<template>
    <Modal
        v-model="_value"
        width="650"
        title="快速生成保险承诺函"
        @on-visible-change="visibleChange"
        ok-text="关闭"
        cancel-text=""
      >
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="reqParams.certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="车主名称">
          <Input placeholder="车主名称" v-model="reqParams.vehicleOwnerName"></Input>
        </Form-item>
        <Form-item label="车牌号码">
          <Input placeholder="车牌号码" v-model="reqParams.registrationNum"></Input>
        </Form-item>
        <Form-item label="车牌颜色">
          <Input placeholder="车牌颜色" v-model="reqParams.registrationColor"></Input>
        </Form-item>
        <Form-item label="车架号">
          <Input placeholder="车架号" v-model="reqParams.vin"></Input>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="reqParams.setupDatetime"></DatePicker>
        </Form-item>
        <Form-item label="交强险承保机构">
          <Select
            placeholder="请选择交强险公司"
            v-model="reqParams.mliftainsurancechannel"
            filterable
            remote
            :remote-method="searchMLIFTAinsuranceChannel"
            :loading="searchMLIFTAinsuranceChannelLoading"
            class="field" style="width: 70%;"
            clearable>
            <Option v-for="(option, index) in searchMLIFTAinsuranceChannelList" :value="option.name" :key="option.name">{{option.name}}</Option>
          </Select>
        </Form-item>
        <Form-item label="交强险到期日">
          <DatePicker type="date" placeholder="交强险到期日" style="width: 200px;margin-right: 10px;"
                      v-model="reqParams.mliftainsurancechanneldatetime"></DatePicker>
        </Form-item>
        <Form-item label="商业险承保机构">
          <Select
            placeholder="请选择商业险公司"
            v-model="reqParams.tiinsurancechannel"
            filterable
            remote
            :remote-method="searchTIinsuranceChannel"
            :loading="searchTIinsuranceChannelLoading"
            class="field" style="width: 70%;"
            clearable>
            <Option v-for="(option, index) in searchTIinsuranceChannelList" :value="option.name" :key="option.name">{{option.name}}</Option>
          </Select>
        </Form-item>
        <Form-item label="商业险到期日">
          <DatePicker type="date" placeholder="交强险到期日" style="width: 200px;margin-right: 10px;"
                      v-model="reqParams.tiinsurancechanneldatetime"></DatePicker>
        </Form-item>
        <Form-item label="车主/受保人">
          <Input placeholder="车主/受保人" v-model="reqParams.insured"></Input>
        </Form-item>
        <Form-item label="">
          <Button @click="onClear" style="margin-right: 5px;">清空参数</Button>
          <Button @click="onInsuranceCommitment" style="margin-right: 5px;">生成保险承诺函</Button>
        </Form-item>
      </Form>
    </Modal>
</template>
<script>


  import Vue from 'vue';
  import axios from '@/libs/api.request'
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'quicklygenerateinsurancevideocommitmentmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {

        certificateAreaOptions: [
          {label: '中山', value: 1},
          {label: '江门', value: 2},
        ],

        //交强险选择
        searchMLIFTAinsuranceChannelList:[],
        searchMLIFTAinsuranceChannelLoading:false,

        //商业险选择
        searchTIinsuranceChannelList:[],
        searchTIinsuranceChannelLoading:false,

        reqParams:{
          vehicleOwnerName:null,
          registrationNum:null,
          registrationColor:'黄色',
          vin:null,
          certificateArea:null,
          setupDatetime:null,
          mliftainsurancechannel:null,
          mliftainsurancechanneldatetime:null,
          tiinsurancechannel:null,
          tiinsurancechanneldatetime:null,
          insured:null,
        }
      }
    },
    methods: {
      ...mapActions([
        'PositioningDeviceInfoServ_QuicklyGenerateVideoCertificate'
      ]),
      onClear(){
        this.reqParams.vehicleOwnerName = null
        this.reqParams.registrationNum = null
        this.reqParams.identificationCode = null
        this.reqParams.registrationColor = '黄色'
        this.reqParams.vin = null
        this.reqParams.certificateArea = null
        this.reqParams.setupDatetime = null
        this.reqParams.mliftainsurancechannel = null
        this.reqParams.mliftainsurancechanneldatetime = null
        this.reqParams.tiinsurancechannel = null
        this.reqParams.tiinsurancechanneldatetime = null
        this.reqParams.insured = null
      },
      onInsuranceCommitment() {
        this.reqParams.setupDatetime = new Date(this.reqParams.setupDatetime).getTime()
        this.reqParams.mliftainsurancechanneldatetime = new Date(this.reqParams.mliftainsurancechanneldatetime).getTime()
        this.reqParams.tiinsurancechanneldatetime = new Date(this.reqParams.tiinsurancechanneldatetime).getTime()
        // store.dispatch('PositioningDeviceInfoServ_QuicklyGenerateCertificate', {
        //   params: this.reqParams,
        //   urlparams: null
        // }).then(() => {
        //
        // }).catch(err => {
        //   this.$Message.error(err)
        // });

        axios.request({
          method: 'POST',
          url: '/im/positioningdeviceinfo/quicklygenerateinsurancevideocommitment',
          data: this.reqParams,
          responseType: 'blob'
        }).then(res => {
          let blob = res.data
          let reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = (e) => {
            let a = document.createElement('a')

            let name = ''
            if(this.reqParams.registrationNum){
              name ='承诺函' + this.reqParams.registrationNum + '_' + this.reqParams.registrationColor
            }else{
              name ='承诺函' + this.reqParams.vin
            }

            a.download = name + '.doc'
            a.href = e.target.result
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
        }).catch((error) => {

        })

        // axios.request('/im/positioningdeviceinfo/quicklygeneratecertificate', this.reqParams, {
        //   responseType: 'blob'
        // }).then(res => {
        //     let blob = res.data
        //     let reader = new FileReader()
        //     reader.readAsDataURL(blob)
        //     reader.onload = (e) => {
        //       let a = document.createElement('a')
        //       a.download = 'fileName'
        //       a.href = e.target.result
        //       document.body.appendChild(a)
        //       a.click()
        //       document.body.removeChild(a)
        //     }
        // })
      },
      searchMLIFTAinsuranceChannel(input){
        this.searchMLIFTAinsuranceChannelLoading = true
        if (!input || input.length <= 0) {
          this.searchMLIFTAinsuranceChannelList = []
          this.searchMLIFTAinsuranceChannelLoading = false
        } else {
          store.dispatch('InsuranceChannelServ_SearchByName', {
            params: { name: input },
            urlparams: null
          }).then(() => {
            this.searchMLIFTAinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
            this.searchMLIFTAinsuranceChannelLoading = false
          }).catch(err => {
            this.searchMLIFTAinsuranceChannelLoading = false
          })
        }
      },
      searchTIinsuranceChannel(input){
        this.searchTIinsuranceChannelLoading = true
        if (!input || input.length <= 0) {
          this.searchTIinsuranceChannelList = []
          this.searchTIinsuranceChannelLoading = false
        } else {
          store.dispatch('InsuranceChannelServ_SearchByName', {
            params: { name: input },
            urlparams: null
          }).then(() => {
            this.searchTIinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
            this.searchTIinsuranceChannelLoading = false
          }).catch(err => {
            this.searchTIinsuranceChannelLoading = false
          })
        }
      },
      visibleChange(val) {
        if (val) {

        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
